import type { Veldnamen } from './work-quality.api';

/**
 * De naam van een veld, of het pad als er geen naam is — spec-veldnamen, AC1 en AC3.
 *
 * Het portaal verzint niets. Ontbreekt de naam, dan blijft het pad staan: geen lege cel, geen
 * streepje. Dat is de terugval voor een veld dat nog geen vertaling heeft én voor de momenten waarop
 * de platformtabel niet te lezen was — dan ontbreekt de hele kaart.
 */
export function veldnaamVan(pad: string, veldnamen: Veldnamen | undefined): string {
  const naam = veldnamen?.[pad];
  return typeof naam === 'string' && naam.trim() !== '' ? naam : pad;
}

/**
 * Of er naast de naam nog een pad te tonen valt.
 *
 * Staat er geen naam, dan ís de naam het pad, en zou het er twee keer onder elkaar staan.
 */
export function heeftEigenNaam(pad: string, veldnamen: Veldnamen | undefined): boolean {
  return veldnaamVan(pad, veldnamen) !== pad;
}

/**
 * Hoe het pad onder de naam wordt gezet.
 *
 * `break-all` en een maximumbreedte, allebei nodig en om verschillende redenen. Gemeten op
 * 15 september 2026 in een echte browser (donker, "Extra groot", 375 px): zonder afbreken loopt
 * `/nutrientHeader/nutrientDetail/quantityContained` de plakkende eerste kolom uit en wordt hij
 * afgekapt — juist aan het eind, het meest onderscheidende deel. Zonder maximumbreedte dijt die
 * kolom uit tot het pad past en duwt hij de cijfers van het scherm.
 */
export const PADREGEL =
  'mt-0.5 block max-w-[min(60vw,22rem)] break-all font-mono text-[11px] font-normal text-[var(--foreground-muted)]';
